import { useEffect, useState } from "react";

import CloseIcon from '@mui/icons-material/Close';
import FeedIcon from '@mui/icons-material/Feed';
import { Input, TextArea } from "../../../../../common/Input";
import { StatusBadge } from "../../../../../common/Badge";
import { Button } from "../../../../../common/APICommon";
import { WorkflowStatus } from "../../../../../utils/enums";
import { ConfirmationModal } from "../../../../../common/Modal";
import { EmployeeListViewModal } from "./EmployeeListViewModal";

export const MRFDetailsModal = ({
  visible, onClose, onCancel, onComplete, modalName, data, form, setForm,
  onUpdateCandidates, onUpdateCandidate, onUpdateMRF, showGeneralMessage
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmConfig, setConfirmConfig] = useState({});

  useEffect(() => {
    if (visible && data) {
      setForm({
        requester: data.requester?.fullName || "",
        position: data.position?.description || "",
        department: data.department?.description || "",
        numberOfVacancies: data.numberOfVacancies || "",
        targetStartDate: data.targetStartDate ? data.targetStartDate.split('T')[0] : "",
        requestedDate: data.requestedDate ? data.requestedDate.split('T')[0] : "",
        qualification: data.qualification || "",
        requesterNotes: data.requesterNotes || "",
      });
    }
  }, [visible, data, setForm]);

  if (!visible) return null;

  const handleCancelModal = () => {
    setConfirmConfig({ title: "Cancel Request", message: "Are you sure you want to cancel this request?", confirmText: "Yes, Cancel", type: "warning", onConfirm: async () => { await onCancel(); onClose(); } });
    setShowConfirmModal(true);
  }

  const handleCompleteModal = () => {
    setConfirmConfig({ title: "Complete Request", message: "Are you sure? This cannot be reverted!", confirmText: "Yes, Proceed", type: "info", onConfirm: async () => { await onComplete(); onClose(); } });
    setShowConfirmModal(true);
  }

  // Condition to show or hide the cancell and update button
  const isTerminalStatus = [WorkflowStatus.CANCELLED, WorkflowStatus.COMPLETED, WorkflowStatus.ONBOARDING].includes(data?.status);

  return (
    <>
      <div role="dialog" className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 text-gray-700 overflow-auto">
        <div className="bg-gray-50 w-full m-2 md:m-0 md:w-[90%] lg:w-[80%] rounded-lg shadow-xl max-h-[90vh] flex flex-col relative">
          <div className="flex justify-between items-center px-6 py-2 border-b border-gray-200 sticky top-0 bg-white z-10 rounded-t-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-800 flex items-center space-x-2"><FeedIcon fontSize="large" className="text-blue-400" /><span className="text-xl text-gray-600">{modalName}</span></h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-700 p-1 bg-transparent border-none"><CloseIcon fontSize="medium" /></button>
          </div>

          <div className="p-6 grid grid-cols-1 lg:grid-cols-2 gap-3 overflow-y-auto flex-grow">
            <div>
              <div className="mb-6 border border-gray-300 rounded-lg bg-white px-4 shadow-sm">
                <div className="py-1 border-b border-gray-300"><h3 className="font-medium text-gray-700">HR Information</h3></div>
                <div className="pb-3 pt-2 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-2">
                  <Input label="Processor Position" value={data?.processor?.positionDescription || "--Not available--"} isDisabled />
                  <Input label="Processed By" value={data?.processor?.fullName || "--Not available--"} isDisabled />
                </div>
              </div>

              <div className="border border-gray-300 rounded-lg bg-white px-4 shadow-sm">
                <div className="flex justify-between items-center py-1 border-b border-gray-300"><h3 className="font-medium text-gray-700">MRF Details</h3><StatusBadge status={data?.status ?? null} /></div>
                <div className="pb-3 pt-2 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-2">
                  <Input label="Position Title" value={form.position} isDisabled />
                  <Input label="Department" value={form.department} isDisabled />
                  <Input label="Vacancies" value={form.numberOfVacancies} isDisabled />
                  <Input label="Target Start" type="date" value={form.targetStartDate} isDisabled />
                  <Input label="Requested Date" type="date" value={form.requestedDate} isDisabled />
                </div>
                <TextArea label="Qualification" value={form.qualification} isDisabled rows={10} />
                <TextArea label="Requester Notes" value={form.requesterNotes} isDisabled rows={5} />
              </div>
            </div>

            <div className="mb-6 pb-3 border border-gray-300 rounded-lg bg-white px-4 shadow-sm">
              <EmployeeListViewModal data={data?.candidates || []} mrfStatus={data?.status} mrfId={data?.id} onUpdateCandidate={onUpdateCandidate} showGeneralMessage={showGeneralMessage} />
            </div>
          </div>

          <div className="flex justify-end space-x-2 p-6 border-t border-gray-200 sticky bottom-0 bg-white z-10 rounded-b-lg shadow-sm">
            {/* <button onClick={onClose} className="bg-gray-400 hover:bg-gray-500 cursor-pointer px-5 py-3 text-white rounded-md transition-colors border-none">Close</button> */}
            <Button
              name="Close"
              onClick={onClose}
              className="bg-gray-400 hover:bg-gray-500"
            />
            {/* Only show these buttons if the request is NOT Cancelled or Completed */}
            {!isTerminalStatus && (
              <>
                <Button
                  name="Cancel Request"
                  onClick={handleCancelModal}
                  className="bg-orange-500 hover:bg-orange-600"
                />
                <Button
                  name="Mark as Completed"
                  onClick={handleCompleteModal}
                  className="bg-blue-500 hover:bg-blue-600"
                />
              </>
            )}
          </div>
        </div>
      </div>
      <ConfirmationModal visible={showConfirmModal} onClose={() => setShowConfirmModal(false)} onConfirm={confirmConfig.onConfirm} title={confirmConfig.title} message={confirmConfig.message} confirmText={confirmConfig.confirmText} type={confirmConfig.type} />
    </>
  );
};